import '../dist/video.css'
import '../blueprints/video-player-starter-v1.ts'
import '../blueprints/video-background-v1.ts'
import '../blueprints/video-v1.ts'
import '../blueprints/video-v2.ts'
import '../blueprints/video-popup-v1.ts'
